import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The surprising performance boost from changing gif embeds",
  "description": "",
  "published": "2020-04-06T00:00:00.000Z",
  "redirect_from": ["/blog/the-surprising-performance-boost-from-changing-gif-embeds/swizec/9365"],
  "categories": "Front End, Technical",
  "hero": "./img/J26iwxB.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`wanna hear something cool?`}</p>
    <p>{`You can 2x your Lighthouse performance score just by changing how you embed 8 gifs on a gigantic 6000 word page with 130 requests and 16megs of data.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/8a9c00ef2e7f3ac0be6ef1956472c895/6c745/J26iwxB.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.51121076233184%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'331\\'%20viewBox=\\'0%200%20400%20331\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%2015c-1%202%200%203%203%203%2013%200%2022%2015%2017%2029l-1%206c3%202%208-9%207-17s-7-15-14-19c-5-2-12-4-12-2m75%200c-1%201%203%203%206%203l10%205c6%206%208%2017%204%2026-6%2011-20%2015-30%208-11-8-14-23-5-32%202-3%200-5-2-2-12%2010-7%2033%209%2039%2024%209%2044-20%2027-39-5-6-18-11-19-8m75%200c-1%201%200%202%204%202%2025%205%2024%2040%200%2043-14%201-24-8-24-22-1-6-2-8-3-3-3%208%204%2021%2013%2025%2025%2013%2048-19%2028-39-5-5-17-9-18-6m74%200c0%201%201%202%206%203%208%201%2016%208%2017%2016%204%2020-20%2034-35%2020-7-6-8-12-6-24%201-4-2-3-3%200-3%208%200%2022%208%2027%2022%2018%2052-10%2035-33-5-7-19-13-22-9m0%2060l-1%204c0%204%200%204%203%204l3-1h2c4%203%208-3%205-7-2-2-4-1-6%201s-5%203-5%201l2-1%202-1h-5M33%2077h-2l-1%203c0%203%200%203%201%201l2-2%201%202c0%202%200%202%201%200l1-2%201%202c1%203%202%204%204%201h2l1-1c1-2%201-2%202%200%200%203%202%203%202%200l1-2%201%202c0%203%202%203%202%200%201-2%201-2%201%200l1%202h8l1-2%201-2%201%202%201%202%201-1h2c1%202%202%202%203%201h3c1%201%204-1%204-3-1-2-4-4-5-2h-7c-2-2-5-1-5%202v3l-1-3c-1-3-4-4-5-1-1%202-1%202-1%200-1-2-12-3-12%200l-1-1h-4c-2%201-2%201-2-1s-1-3-3%200m155%202c0%204%200%204%202%204l4-1h13l1%201v-7c0-2-2%200-2%202s0%202-1%201c0-2-9-2-10%200-1%201-1%201-1-2l-3-2c-3%200-3%200-3%204m141-2l-1%203c0%202%200%203%201%202%200-4%202-5%202-2%200%202%203%203%205%202h2v3l4-1%202-1%201-2c0-4%202-4%202-1%201%204%205%203%205%200v-3h-23m-223%202v3c1%201%205%202%205%200h1l9%201h9v-3c0-3%200-3-1-1s-1%202-1%200c-1-2-5-2-4%200l-1%202-1-2-2-2c-2%200-2%200-2%202v2l-1-2c0-2-3-2-5-1h-1c0-2-4-1-5%201m220%2013l3%206%202-2v-2l1%202c1%202%203%203%203%200h1l3%202%202-2h1c0%202%201%202%203%202%204-1%204-4%200-6-3-2-3-2-3%200s0%202-1%201l-3-1c-1%201-2%200-2-1-1-1-1-1-2%201s-1%202-1%200c-1-3-3-3-3%200l-1%203v-3c-1-2-3-3-3%200m26%201c-1%205-1%205%201%204s2-1%204%201l3%201%203-2c2-1%202-1%202%201s0%202%201%201l3-1c3-1%202-5-1-6l-3%201h-2c-3-2-5-1-4%202%200%202-1%201-2-1-2-5-3-5-5-1M54%20109l-1%2019a237%20237%200%2001-1%2032c2%202%203%201%203-2l1-11%201-22v-16h-3m6%2045l-7%2012-3-7-3-8-1-4c0-2-2-3-4-2-3%201-3%202%200%206%202%202%204%206%204%209%203%208%207%2011%2010%207%203-3%2011-22%2010-23s-2%202-6%2010m63%203l-2%203c-2%202-2%202-4%200-1-1-1-1-3%201s-2%202-3%200c-3-3-11-3-14%201-3%203-2%205%202%206%205%200%207%200%208-3%200-2%200-2%203-1%202%202%205%202%205%201h3c2%200%203%200%205-3%203-4%204-6%202-6l-2%201m-32%204c-2%204-3%204-3%202%200-3-3-3-4%201l-2%202-1-2c0-2-1-3-2-3-3%200-3%203%200%206%203%204%205%204%206%201%200-2%200-2%201-1%202%202%205%201%208-4%203-6%204-6%202-6l-5%204m108%2032c-2%201%202%203%206%203%202%200%2010%205%2012%209%207%2010%203%2024-8%2030-14%207-31-5-30-21%201-5-1-7-2-3-2%208%200%2015%206%2022%2010%209%2023%2010%2033%200%209-9%2010-21%203-31-5-6-16-11-20-9m72%201l3%201c4%200%2010%203%2014%207%2016%2018-8%2044-27%2031-8-5-10-12-8-24%200-5-1-6-3-1-4%209%200%2021%208%2026%2023%2019%2052-15%2030-35-6-6-17-9-17-5m-217%201l3%201c11%200%2020%2012%2019%2023-2%2016-22%2024-33%2014-3-2-5-3-5-1s8%207%2013%208c23%204%2037-23%2021-40-6-6-18-9-18-5m72-1l5%202c20%204%2024%2032%205%2039-20%209-37-14-24-31%203-6%204-6%202-6-3%200-8%207-9%2011-5%2016%207%2031%2023%2031%2025%200%2032-36%209-45-5-2-11-3-11-1m65%2058l-1%204c0%204%200%204%202%204l4-1h1c3%202%209%201%2010-2l1-2v2c1%203%202%202%202-1%201-3-1-5-2-3l-2%201h-5c-1-1-2-1-3%201-2%201-2%201-2-1s-4-4-5-2m72%201c-1%201%200%203%203%203l1%201h-5c0%201%203%203%204%202h5c3%200%203%200%202-1l-2-1c0-2%204-1%205%201%202%202%206%201%207-2%201-4-4-7-7-4h-1c0-2-5-1-6%202%200%202-1%202-3%200-2-1-2-1%200-1h2c-1-2-5-2-5%200m55%202l1%204%201-1%202-3c3-1%203-1%203%202l1%203%201-3c1-2%201-2%201%200%201%202%205%203%205%201l1-1%201%202%202%202%202-1%202-1%201-2v-2l1%202c1%202%205%203%205%201l2-2v1c-2%201-2%201%205%201%206%201%206%201%206-2v-2l1%202c1%204%203%204%204%201v-2l1%202c1%203%205%202%205-1s-7-4-7-1h-1c-2-3-4-2-4%200l-1%202v-2c0-2-8-2-10-1h-16l-4-1-5-1-4-1c-2%200-2%200-2%204m-292-2v7l1-1c0-3%205-3%205-1%201%203%205%203%205%200h1c1%202%201%202%201%200l2-2v1l1%202c1%201%201%200%201-1v-2l1%202c1%203%208%203%208%200l1-2c1-1%201%200%201%201%200%204%202%204%202%201l1-2v2c0%203%202%203%202%200l1-2%201%202c0%201%201%202%205%202%203%200%204%200%204-2l1-2%201%202c0%201%201%202%204%202l3-1-1-1c-1%201-2%200-2-1l2-1%201-1h-6l-5-1c-3%200-4%201-4%202l-1%202-1-2c0-1-1-2-5-2l-7%201h-1l-2-1h-3l-1-2-1%201-2%201-2%201h-1l-3-1c-1%201-2%200-3-1h-5m74%203l-1%204%201-1h12l2%201%202-1-1-1-2-1c0-3%203-2%204%201%201%202%2021%202%2024%201h1c1%201%201%200%201-2s0-3-1-2l-5-2-2-1c-2%200-2%200-1%201v1l-1%202h-1c0-2-2-2-12-2l-14%201c-1%202-2%201-2-1-1-3-3-2-4%202m80%2011l-1%204v4l2-2c2-2%204-3%204%200%200%202%202%201%202-1l1-2%201%202c1%202%205%204%205%202h1c2%201%204%201%204-1h-1l-2-1c0-2%204-2%204%200%201%202%205%203%205%201h2c1%202%202%202%203%201h5l2-1c1%202%202%202%204%201v-3c-2-1-2-1%200-1v-1h-17c-2-1-3-2-4-1h-2l-2%201h-7l-5-1c-1-2-3-2-4-1m144%201c0%205%202%208%204%204v-2l1%202c1%202%203%203%203%200l1%201h6l2%201c3-1%204-5%201-6l-2-1c-1-1-1%200-1%201%200%202%200%202-1%201l-3-1c-1%201-2%200-2-1-1-1-1-1-2%201l-1%201c0-3-2-3-3-1v2l-2-2c-1-2-1-2-1%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8a9c00ef2e7f3ac0be6ef1956472c895/ca0a1/J26iwxB.webp 223w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/75680/J26iwxB.webp 445w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/8d1ba/J26iwxB.webp 890w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/f0cd5/J26iwxB.webp 893w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8a9c00ef2e7f3ac0be6ef1956472c895/e92b6/J26iwxB.png 223w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/e66bf/J26iwxB.png 445w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/4ef49/J26iwxB.png 890w", "/static/8a9c00ef2e7f3ac0be6ef1956472c895/6c745/J26iwxB.png 893w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8a9c00ef2e7f3ac0be6ef1956472c895/4ef49/J26iwxB.png",
                "alt": "Change in Lighthouse score after change",
                "title": "Change in Lighthouse score after change",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Change in Lighthouse score after change`}</figcaption>{`
  `}</figure></p>
    <p><img parentName="p" {...{
        "src": "/8a8da46e9044de653d356734416f1b02/media-3o6gDPXMNxFhvHdcf6-giphy.gif",
        "alt": "whoa giphy"
      }}></img></p>
    <h2 {...{
      "id": "how-i-found-out"
    }}>{`How I found out`}</h2>
    <p>{`On the internet, ain't nobody got time to read 3 paragraphs of emotion setting. You'd find it boring.`}</p>
    <p>{`So we use gifs.`}</p>
    <p><img parentName="p" {...{
        "src": "/56504ae0999d5a31bef2cf25be4f7375/media-90F8aUepslB84-giphy.gif",
        "alt": "pratt_surprise giphy"
      }}></img></p>
    <p>{`But looking for gifs breaks your writing flow. You leave the editor, go on giphy, search for the emotion, dig through the search results, copy paste the link, go back to your editor ...`}</p>
    <p>{`Wait what was I saying? 🤔`}</p>
    <p>{`Happens every time. Slows you down. Wasted effort.`}</p>
    <p>{`What if you could find the perfect gif without leaving your editor? Write a search right in your markdown?`}</p>
    <p><inlineCode parentName="p">{`![](giphy:pratt_surprise)`}</inlineCode></p>
    <p>{`Becomes`}</p>
    <p><img parentName="p" {...{
        "src": "/56504ae0999d5a31bef2cf25be4f7375/media-90F8aUepslB84-giphy.gif",
        "alt": "pratt_surprise giphy"
      }}></img></p>
    <p>{`Been using that with `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetter.App`}</a>{` for over a year now and it is wonderful. Saves so much time and effort. 👌`}</p>
    <p>{`This weekend I turned it into my first Gatsby plugin – `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/gatsby-remark-giphy"
      }}>{`gatsby-remark-giphy`}</a>{`.`}</p>
    <p>{`Now you can use it too ❤️`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1246595122197721088"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "93.72197309417041%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'374\\'%20viewBox=\\'0%200%20400%20374\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2016c-7%204-10%2015-6%2021s14%209%2020%205c3-2%203-4%200-4-4%200-2-5%202-5l2-1%202-1v-8c-4-7-13-10-20-7m45%2041h-3l-1%201-1%201c-2%200-2%202-1%202v2c-2%202-2%202%200%202s2%200%201%202c-2%203-1%203%201%202%202-2%203-2%205%200l2%202v-3c0-2%200-3%202-3v-4c1-2%201-2-1-2s-3-1-3-2h-1M19%20210l-3%203v27l1%2028%203%202c4%201%204%202-1%202h-3v5l1%204h6l6%201c1%201-1%201-6%201h-7v9c0%208%200%208%203%2011l3%203h93v-4c0-3%200-4-2-4v-2c2-1%202-2%201-3v-2l1-1c0-2-4-3-10-2H89c-2%200-2%200-3-2l-2-2-3-2c0-1%203-9%205-9l2-3c1-3%202-3%205-3s4%200%204-2l1-2%202%202c1%202%202%202%206%202l7%201%202-1-5-1c-7-1-7-2%200-3l3-1c-9%200-11-3-3-3l5-1-5-1c-6%200-4-2%202-2h3v-48h-13l-15%201h-1l-32-1H22l-3%203m35%2033c-2%200-2%200%200%202v2c-1%201-2%202-2%205%200%206-2%2011-4%2011l-2%201c0%201%200%202%202%202l4%202c2%203%203%203%209%200%205-3%205-3%202-6-2-3-6-15-5-18%200-2-1-2-4-1m24%2021c-4%202-6%204-4%206%202%203%201%206-2%207l-4%202c-2%203-9%206-7%204l-3-1c-4%200-7%201-6%202%201%203-13-2-16-6-1%200%202-3%204-3%204%200%205-3%203-7-1-3-2-3-6-2-6%201-7%202-6%203l2%207%202%208%203%206c2%207%209%2010%2018%2010%209-1%2013-5%2022-27l4-8c1-3%201-3-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/ca0a1/techletter.app-screenshot-1586186299871.webp 223w", "/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/75680/techletter.app-screenshot-1586186299871.webp 445w", "/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/0ba47/techletter.app-screenshot-1586186299871.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/e92b6/techletter.app-screenshot-1586186299871.png 223w", "/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/e66bf/techletter.app-screenshot-1586186299871.png 445w", "/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/6af66/techletter.app-screenshot-1586186299871.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/51ac37b2fef4cc05f8d9c03fb9edcb0d/6af66/techletter.app-screenshot-1586186299871.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "3-ways-to-embed-a-gif"
    }}>{`3 ways to embed a gif`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/gatsby-remark-giphy"
      }}>{`gatsby-remark-giphy`}</a>{` supports 3 ways to embed a gif`}</p>
    <ul>
      <li parentName="ul">{`plain `}<inlineCode parentName="li">{`<img>`}</inlineCode></li>
      <li parentName="ul">{`using HTML5 video`}</li>
      <li parentName="ul">{`as an iframe`}</li>
    </ul>
    <p>{`Configure via `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{` and the plugin changes how it transforms markdown nodes.`}</p>
    <p>{`Here's what happens.`}</p>
    <p>{`At build time, gatsby-remark-giphy visits each markdown image node whose URL starts with `}<inlineCode parentName="p">{`giphy:`}</inlineCode>{`, pings the `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/"
      }}>{`Giphy API`}</a>{`, and runs 1 of 3 functions:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`embedGif`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`embedVideo`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`embedIframe`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "embedgif"
    }}>{`embedGif`}</h3>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20embedGif(imageNode%2C%20giphy%3A%20GIFObject)%20%7B%0A%20%20%20%20const%20search%20%3D%20imageNode.url.replace(%2F%5Egiphy%3A%2F%2C%20%22%22)%3B%0A%0A%20%20%20%20imageNode.alt%20%3D%20search%3B%0A%20%20%20%20imageNode.url%20%3D%20giphy.images.downsized_large.url%3B%0A%20%20%20%20imageNode.title%20%3D%20imageNode.title%20%7C%7C%20search%3B%0A%0A%20%20%20%20return%20imageNode%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "550px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2037c-2%203-1%20167%201%20168%202%203%20348%203%20350%200%202-1%203-165%201-168S26%2034%2024%2037\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5348072cd327691a8b00a12109c07530/ca0a1/techletter.app-screenshot-1586186176114.webp 223w", "/static/5348072cd327691a8b00a12109c07530/75680/techletter.app-screenshot-1586186176114.webp 445w", "/static/5348072cd327691a8b00a12109c07530/12b65/techletter.app-screenshot-1586186176114.webp 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5348072cd327691a8b00a12109c07530/e92b6/techletter.app-screenshot-1586186176114.png 223w", "/static/5348072cd327691a8b00a12109c07530/e66bf/techletter.app-screenshot-1586186176114.png 445w", "/static/5348072cd327691a8b00a12109c07530/dd45a/techletter.app-screenshot-1586186176114.png 550w"],
                "sizes": "(max-width: 550px) 100vw, 550px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5348072cd327691a8b00a12109c07530/dd45a/techletter.app-screenshot-1586186176114.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`To embed a gif, we maintain the markdown-ness of this node. Change the URL to the search result and add a title. Further markdown transformers will turn it into a regular image.`}</p>
    <p>{`Something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=html&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%3Cimg%20src%3D%22https%3A%2F%2Fmedia.giphy.com%2Fmedia%2F5VKbvrjxpVJCM%2Fgiphy.gif%22%20alt%3D%22search%22%20%2F%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "742px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "25.112107623318387%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'101\\'%20viewBox=\\'0%200%20400%20101\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2028c-2%203-1%2046%200%2047%202%202%20362%202%20364%200%201-1%202-44%200-47-1-3-363-3-364%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/78d24df5b41ca9218c43fec759d15d8e/ca0a1/techletter.app-screenshot-1586186176604.webp 223w", "/static/78d24df5b41ca9218c43fec759d15d8e/75680/techletter.app-screenshot-1586186176604.webp 445w", "/static/78d24df5b41ca9218c43fec759d15d8e/28367/techletter.app-screenshot-1586186176604.webp 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/78d24df5b41ca9218c43fec759d15d8e/e92b6/techletter.app-screenshot-1586186176604.png 223w", "/static/78d24df5b41ca9218c43fec759d15d8e/e66bf/techletter.app-screenshot-1586186176604.png 445w", "/static/78d24df5b41ca9218c43fec759d15d8e/0f2bc/techletter.app-screenshot-1586186176604.png 742w"],
                "sizes": "(max-width: 742px) 100vw, 742px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/78d24df5b41ca9218c43fec759d15d8e/0f2bc/techletter.app-screenshot-1586186176604.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This is the slowest.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "644px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/de5f5a26a51434e7639542c08bb40fef/78274/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.01345291479821%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'155\\'%20viewBox=\\'0%200%20400%20155\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M46%2014c0%201%201%202%204%202%2014%203%2022%2016%2017%2030-2%206-1%208%202%204%208-10%203-28-10-34-6-3-13-4-13-2m76%200c-1%201%200%202%204%202%2026%205%2023%2043-3%2043-18%200-28-21-17-35%202-3%202-5-1-2-4%203-6%209-6%2015%200%2019%2018%2031%2035%2023%2021-11%2016-43-8-47l-4%201m75%200c0%201%201%202%204%202%2021%204%2026%2031%207%2041-15%208-33-5-32-23%201-4-1-4-2%200-2%2015%209%2028%2025%2028%2029%200%2032-44%202-49l-4%201m75%201l2%201c7%200%2015%206%2018%2012%2011%2022-17%2042-34%2024-6-5-7-12-5-23%201-3-1-2-3%200-2%205-1%2016%203%2022%207%2012%2025%2015%2036%205s12-25%202-36c-6-5-19-9-19-5M43%2079c0%202%200%203%201%202%201-4%202-5%202-2l1%203%201-2c0-4%202-4%202%200%200%202%200%202%201%201%201-4%202-5%202-2s0%203%205%203c4%200%205%200%205-2l1-2c1-1%201%200%201%201l1%203%201-1h1c1%202%2010%201%2010-1v-3H67c-2-2-6-1-6%202l-1%203v-3c0-2-1-3-2-3l-2%201v2l-1-1c-1-2-2-2-6-2h-6v3m284%2011l2%207%201-2%201-2%202%203c1%202%201%202%202%200v-2l2%202c2%202%202%202%203%201%201-2%202-2%203%200%201%201%203%201%204-1s1-3-1-5c-3-2-4-2-4%200s0%202-2%201h-2c-2%201-2%201-2-1s0-2-1%201l-2%203v-3c-1-3-3-3-3%200%200%202%200%202-1%200l-2-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/de5f5a26a51434e7639542c08bb40fef/ca0a1/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.webp 223w", "/static/de5f5a26a51434e7639542c08bb40fef/75680/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.webp 445w", "/static/de5f5a26a51434e7639542c08bb40fef/f847d/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.webp 644w"],
              "sizes": "(max-width: 644px) 100vw, 644px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/de5f5a26a51434e7639542c08bb40fef/e92b6/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.png 223w", "/static/de5f5a26a51434e7639542c08bb40fef/e66bf/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.png 445w", "/static/de5f5a26a51434e7639542c08bb40fef/78274/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.png 644w"],
              "sizes": "(max-width: 644px) 100vw, 644px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/de5f5a26a51434e7639542c08bb40fef/78274/9543257d7dd2cbf88a0009844cbe7e2900309101-68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67.png",
              "alt": "9543257d7dd2cbf88a0009844cbe7e2900309101 68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67",
              "title": "9543257d7dd2cbf88a0009844cbe7e2900309101 68747470733a2f2f692e696d6775722e636f6d2f6c6852647169452e706e67",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You're loading the gif as soon as the page renders. Whether it's visible or not. And you have to wait for the whole gif to download before it plays.`}</p>
    <h3 {...{
      "id": "embedvideo"
    }}>{`embedVideo`}</h3>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20embedVideo(imageNode%2C%20giphy%3A%20GIFObject%2C%20embedWidth)%20%7B%0A%20%20%20%20const%20srcHTML%20%3D%20%60%3Csource%20src%3D%24%7Bgiphy.images.looping.mp4%7D%20type%3D%22video%2Fmp4%22%20%2F%3E%60%3B%0A%0A%20%20%20%20imageNode.type%20%3D%20%22html%22%3B%0A%20%20%20%20imageNode.children%20%3D%20undefined%3B%0A%20%20%20%20imageNode.value%20%3D%20%60%3Cvideo%20style%3D%22margin%3A%20auto%20auto%3B%20display%3A%20block%3B%20max-width%3A%20%24%7BembedWidth%7D%22%20autoplay%20loop%20muted%20playsinline%20loading%3D%22lazy%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%24%7BsrcHTML%7D%0A%20%20%20%20%20%20%20%20%3C%2Fvideo%3E%60%3B%0A%0A%20%20%20%20return%20imageNode%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.668161434977584%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'151\\'%20viewBox=\\'0%200%20400%20151\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2027l-1%2057%201%2048h375V83l-1-57v-7H13v8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e8ff053acd7b2079571e85c3f3ec8468/ca0a1/YNQOHBz.webp 223w", "/static/e8ff053acd7b2079571e85c3f3ec8468/75680/YNQOHBz.webp 445w", "/static/e8ff053acd7b2079571e85c3f3ec8468/8d1ba/YNQOHBz.webp 890w", "/static/e8ff053acd7b2079571e85c3f3ec8468/3838e/YNQOHBz.webp 1335w", "/static/e8ff053acd7b2079571e85c3f3ec8468/e11e5/YNQOHBz.webp 1780w", "/static/e8ff053acd7b2079571e85c3f3ec8468/8df42/YNQOHBz.webp 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e8ff053acd7b2079571e85c3f3ec8468/e92b6/YNQOHBz.png 223w", "/static/e8ff053acd7b2079571e85c3f3ec8468/e66bf/YNQOHBz.png 445w", "/static/e8ff053acd7b2079571e85c3f3ec8468/4ef49/YNQOHBz.png 890w", "/static/e8ff053acd7b2079571e85c3f3ec8468/4e814/YNQOHBz.png 1335w", "/static/e8ff053acd7b2079571e85c3f3ec8468/701e9/YNQOHBz.png 1780w", "/static/e8ff053acd7b2079571e85c3f3ec8468/a878e/YNQOHBz.png 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e8ff053acd7b2079571e85c3f3ec8468/4ef49/YNQOHBz.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Here we change the node into HTML and tell markdown exactly what to do. The gif becomes an HTML5 video element playing an mp4.`}</p>
    <p>{`Adding `}<inlineCode parentName="p">{`autoplay loop muted playsinline`}</inlineCode>{` makes it behave like a gif. But with one crucial difference 👉 mp4 is optimized for streaming.`}</p>
    <p>{`That means your browser can play the video `}<em parentName="p">{`while it's downloading`}</em>{`. `}<strong parentName="p">{`And`}</strong>{` the filesize is smaller.`}</p>
    <p>{`2.29MB gif vs. 1.09MB mp4 for our surprise example. 🤯`}</p>
    <p>{`This is the fastest.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "667px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/fae376f119609e807078595391635ee8/295bd/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "38.11659192825112%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'152\\'%20viewBox=\\'0%200%20400%20152\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M54%2015c-2%201-1%202%203%203%206%201%208%202%2012%206%209%209%208%2024-3%2032-6%204-17%204-23-1-5-3-7-3-5%200s11%207%2016%207c21%200%2032-26%2017-40-4-5-15-9-17-7m73%200c-2%201-1%202%203%203%2020%203%2024%2031%206%2039-21%209-39-17-24-34%204-4%202-5-2-1-10%2010-8%2025%202%2034%2015%2013%2039%202%2039-18%200-9-8-19-15-22-6-2-9-2-9-1m72%200c-2%201-1%202%203%203%2019%203%2025%2026%209%2037-6%205-17%205-22%201-7-6-9-9-10-17%200-10-2-11-3-2-1%2018%2018%2030%2034%2023%2014-7%2018-23%208-37-3-5-17-10-19-8m73%200c-2%201-1%202%204%203%2016%203%2022%2021%2012%2033-15%2017-41%203-36-18l1-6c-2-1-3%201-4%207-5%2027%2032%2039%2044%2015%208-15-1-31-18-34h-3M99%2078c-1%203-1%206%201%203%200-2%201-2%202-1%203%202%207%202%207%201h8c2%202%204%200%204-2%200-3%200-3-5-3l-5%201h-1c0-2-4-1-5%201%200%202%200%202-2-1-1-4-3-4-4%201m91%200c0%204%202%205%205%203h3c1%201%202%201%203-1%201-1%202-2%203-1v1c-2%200-2%200-1%201%201%202%204%200%204-1v-3l1%202%201%203v-7h-1c-1%202-2%202-2%201h-6l-3%201-1%201-1-2c0-1%200-2-2-2-3%200-3%200-3%204m161-2h-12c-10%200-11%201-11%203s3%204%205%202h2v3c2%200%207-3%207-5s0-2%201%200c1%203%203%204%205%201%201-1%202-2%203-1v1l-2%201%205%201c4%200%204-1%205-3%200-3-2-5-4-3-1%202-1%202%201%203v1l-3-2c-1-3-1-3-2-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fae376f119609e807078595391635ee8/ca0a1/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.webp 223w", "/static/fae376f119609e807078595391635ee8/75680/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.webp 445w", "/static/fae376f119609e807078595391635ee8/b09c6/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.webp 667w"],
              "sizes": "(max-width: 667px) 100vw, 667px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fae376f119609e807078595391635ee8/e92b6/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.png 223w", "/static/fae376f119609e807078595391635ee8/e66bf/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.png 445w", "/static/fae376f119609e807078595391635ee8/295bd/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.png 667w"],
              "sizes": "(max-width: 667px) 100vw, 667px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/fae376f119609e807078595391635ee8/295bd/f04e81be56821573c3b13431282e080864c48c94-68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67.png",
              "alt": "f04e81be56821573c3b13431282e080864c48c94 68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67",
              "title": "f04e81be56821573c3b13431282e080864c48c94 68747470733a2f2f692e696d6775722e636f6d2f6e305a32536c562e706e67",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`But this result is suspicious, we'll get to that.`}</p>
    <h3 {...{
      "id": "embediframe"
    }}>{`embedIframe`}</h3>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255%2C255%2C255%2C1)&t=seti&wt=none&l=typescript&ds=true&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=48px&ph=32px&ln=false&fl=1&fm=Hack&fs=14px&lh=133%25&si=false&es=2x&wm=false&code=function%2520embedIframe(imageNode%252C%2520giphy%253A%2520GIFObject%252C%2520embedWidth)%2520%257B%250A%2520%2520%2520%2520const%2520responsivePadding%2520%253D%2520Math.round(%250A%2520%2520%2520%2520%2520%2520%2520%2520(Number(giphy.images.original.height)%2520%252F%250A%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520Number(giphy.images.original.width))%2520*%250A%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520%2520Number(embedWidth.replace(%2522%2525%2522%252C%2520%2522%2522))%250A%2520%2520%2520%2520)%253B%250A%250A%2520%2520%2520%2520imageNode.type%2520%253D%2520%2522html%2522%253B%250A%2520%2520%2520%2520imageNode.children%2520%253D%2520undefined%253B%250A%2520%2520%2520%2520imageNode.value%2520%253D%2520%2560%253Cdiv%2520style%253D%2522width%253A%2524%257BembedWidth%257D%253Bheight%253A0%253Bpadding-bottom%253A%2524%257BresponsivePadding%257D%2525%253Bposition%253Arelative%253Bmargin%253A%25200%2520auto%2522%253E%253Ciframe%2520src%253D%2522%2524%257Bgiphy.embed_url%257D%2522%2520width%253D%2522100%2525%2522%2520height%253D%2522100%2525%2522%2520style%253D%2522position%253Aabsolute%2522%2520frameborder%253D%25220%2522%2520class%253D%2522giphy-embed%2522%2520allowfullscreen%2520loading%253D%2522lazy%2522%253E%253C%252Fiframe%253E%253C%252Fdiv%253E%2560%253B%250A%250A%2520%2520%2520%2520return%2520imageNode%253B%250A%257D%250A"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "46.63677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'186\\'%20viewBox=\\'0%200%20400%20186\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2026l-1%2074%201%2067h375v-67l-1-74v-7H13v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d3d8a69fe18b969c8d52d35bac9ead84/ca0a1/5W1qqqc.webp 223w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/75680/5W1qqqc.webp 445w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/8d1ba/5W1qqqc.webp 890w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/3838e/5W1qqqc.webp 1335w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/e11e5/5W1qqqc.webp 1780w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/8df42/5W1qqqc.webp 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d3d8a69fe18b969c8d52d35bac9ead84/e92b6/5W1qqqc.png 223w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/e66bf/5W1qqqc.png 445w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/4ef49/5W1qqqc.png 890w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/4e814/5W1qqqc.png 1335w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/701e9/5W1qqqc.png 1780w", "/static/d3d8a69fe18b969c8d52d35bac9ead84/a878e/5W1qqqc.png 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d3d8a69fe18b969c8d52d35bac9ead84/4ef49/5W1qqqc.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Similarly to the video embed, we change the node to HTML and tell markdown exactly what to do.`}</p>
    <p>{`Create an iframe Giphy embed in this case. I borrowed the code from `}<a parentName="p" {...{
        "href": "https://github.com/MichaelDeBoey/gatsby-remark-embedder"
      }}>{`gatsby-remark-embedder`}</a>{` and added `}<inlineCode parentName="p">{`loading="lazy"`}</inlineCode>{` to speed things up.`}</p>
    <p>{`The result is an iframe with some annoying Giphy branding on mouseover and a nice Lighthouse boost.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "571px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3ad5931a4f623df62c6c237536cbfa5e/17d73/c1QcNNs.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.33183856502242%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'249\\'%20viewBox=\\'0%200%20400%20249\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%20128v109h15v-13h3l3%201v6c-3%202-2%205%201%206%203%200%206-3%204-5-2-1-2-2%200-2l1-2c0-3%200-3%203-3s3%200%203-2c0-3%201-4%203-2%200%202%202%201%203-1v-4c-1-1-1-2%201-4%203-3%203-4-1-5-3-1-3-1-3%204l-2%204v-10l-1-11-4-1c-1-2%201-2%2016-2%2010%200%2017%200%2016%201-2%201-2%205%200%206%203%200%205-2%205-4v-3l1%2023v23h21c19%200%2020%200%2020-2-5-10-5-21-2-26%202-3%204-4%205-2%201%201%201%200%201-1%200-2%204-4%206-3l1%2018v16h229V59h10V46h-14V32h-14V18H33v110M203%2020l-2%201c-7%200-8%202-5%206l2%203%201%201%201-1%202-1c2%200%207-5%206-7%200-2-5-3-5-2m-10%2016c-1%202-1%202%201%203%205%202%2011%209%2011%2012-1%202%200%203%202%206l4%205c0%203%203%205%205%205%203%200%204-2%203-6l-9-19c-2-4-3-5-5-5h-8l-1%201v-1c0-2%200-2-3-1m-43%2010l1%202c2%201%201%202-4%202-3%201-6%202-7%204-4%203-4%203%200%201l4-1%203-1c1-2%207-2%207-1l2%201c5-1%206%200%208%204l2%203%201-2c1-1%201-1-1-3l-4-5c-1-2-2-3-4-3l-5-1h-3m39%2025v2l1%205%201%204h1v1l-1%202h1c2-1%203%200%204%205l1%203%201%204-1%206c0%202-1%203-2%203-2%201-3%204%200%205l3%202h1c0-3%200-6%201-4l2%203c3%203%201%203-10%203-9%200-10-1-11-2l1-2%201-3c0-4%200-4-3-4-2%200-4%203-3%208%201%202%200%203-1%201l-2-1v1l-3%201c-3%200-4%200-3%201l-1%202c-2%202-1%203%201%203%201-1%203%200%204%202l3%202-1%201-2%201%203%209%203%2010c2%201%2011-4%2022-11l11-7-1-4c-2-6-2-6%2014-7l14-1h-29v-3c-1-2%200-5%201-2l3%201c2%200%202%200%202-3l-1-4-1%201c0%202-4%202-6%201%200-1-1-2-2-1v-9c2-4%202-5-1-5-1%201-1%200-1-2%200-3-1-5-4-5-2%200-3-1-3-2l-1-3-3-7c0-2-1-3-3-1m21-1c-3%200-4%206-2%208%201%201%201%201-1%204-2%201-3%203-2%203%201%201%202%201%2010-4%203-1%205-5%204-6l1-2c2-2-6-4-10-3m-93%2033l1%203c-1%202%206%206%208%205v-1c-2%200-3-2-1-2l7%203%207%203%202%201-3%201c-4%200-20-6-22-7-2-2-3-2-2%200h-9l-4%201-4-1%203%202%209%201%206%201h3l2%201c-1%201%200%201%201%201l9%203c8%202%2013%202%2011-1%200-2%202-1%205%200%203%203%205%202%202-1l-4-2-2-1c-1-1-3-2-4-1l-7-4-5-3-5-1-4-1m64%2014l-2%205-1%203h7l7%201h-3c-3%200-3%200-3%205l-2-1-1-3-1%204c0%205%201%207%202%205l2-1c1%201%201%201%201-1v-1l3%201c2%200%203-1%201-2-1-1%200-5%201-5l2%203%201%203v-8l1%202%201%203%201-1%201-1h2l1%201v-4l1%201c0%201%201%202%202%201l1-1h1c2%200%202-1-1-7l-2-3h-12l-11%201m-57%2015c-2%206-2%2022%200%2021l1-3c0-3%200-3%201-1h1l2-3%201-7c0-6%200-7-2-7l-3-1c-1-1-1-1-1%201m49%2033l-5%202c-1-2-4%200-4%203-1%204%203%2010%206%2012%207%204%2017-10%2011-15-2-2-2-2-2%200s-2%201-4-1l-2-1m78%2034l-1%205v5h16v-11h-7l-8%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3ad5931a4f623df62c6c237536cbfa5e/ca0a1/c1QcNNs.webp 223w", "/static/3ad5931a4f623df62c6c237536cbfa5e/75680/c1QcNNs.webp 445w", "/static/3ad5931a4f623df62c6c237536cbfa5e/9ac82/c1QcNNs.webp 571w"],
              "sizes": "(max-width: 571px) 100vw, 571px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3ad5931a4f623df62c6c237536cbfa5e/e92b6/c1QcNNs.png 223w", "/static/3ad5931a4f623df62c6c237536cbfa5e/e66bf/c1QcNNs.png 445w", "/static/3ad5931a4f623df62c6c237536cbfa5e/17d73/c1QcNNs.png 571w"],
              "sizes": "(max-width: 571px) 100vw, 571px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/3ad5931a4f623df62c6c237536cbfa5e/17d73/c1QcNNs.png",
              "alt": "c1QcNNs",
              "title": "c1QcNNs",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "685px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/fe53d8472f1e8ffb2f48c1212ed226e9/8ce22/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.668161434977584%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'150\\'%20viewBox=\\'0%200%20400%20150\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M59%2016c-2%201-1%202%203%202%206%201%209%203%2013%207%2013%2015-1%2037-20%2033l-6-1c-2%203%208%205%2014%204%2026-4%2026-41%200-45h-4m71%200c-2%201-1%202%203%202%2018%203%2023%2027%209%2037-8%206-19%205-26-3-7-7-8-14-3-23l2-7c-2%200-7%208-8%2013-2%2019%2017%2033%2034%2024%2018-9%2015-37-4-42-6-2-6-2-7-1m70%200c-1%201-1%201%205%203%2010%202%2016%209%2016%2020%200%2026-38%2027-40%200-1-8-2-9-3-2%200%208%201%2013%206%2018%2021%2020%2052-8%2034-31-3-6-17-11-18-8m71%200c-2%201-1%202%203%202%2018%203%2024%2024%2011%2036-15%2013-37-1-33-20l1-6c-3-2-5%208-4%2014%202%2011%2011%2019%2023%2019%2024%200%2031-32%2010-43-4-2-10-3-11-2M103%2077l-1%204%201-1%202-1%202%201%203%201%203-1-1-1c-2%200-3-2-1-2%201-1%203%200%203%202%201%202%204%203%205%201l-1-1c-2%201-2%200-2-1%200-2%202-2%204%201%201%202%204%203%204%201l2-2v1c-2%201-1%201%206%201%205%201%205%200%205-2%200-3-5-4-7-1h-1c0-2-2-3-4-1h-1l-2-1-2%201h-11c0%202-2%201-2-1-1-3-3-2-4%202m219%2014l1%204c0%201%202%200%203-2l1-2v2c0%202%201%203%203%201l2%201c1%201%201%201%203-1h1c0%202%203%202%205%201%202-2%200-6-2-5l-1-1-1-1-1%202h-4l-1-1c0-2-2-1-2%201v3l-1-3c-2-2-3-3-3%200h-1c-2-3-3-2-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fe53d8472f1e8ffb2f48c1212ed226e9/ca0a1/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.webp 223w", "/static/fe53d8472f1e8ffb2f48c1212ed226e9/75680/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.webp 445w", "/static/fe53d8472f1e8ffb2f48c1212ed226e9/80e32/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.webp 685w"],
              "sizes": "(max-width: 685px) 100vw, 685px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/fe53d8472f1e8ffb2f48c1212ed226e9/e92b6/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.png 223w", "/static/fe53d8472f1e8ffb2f48c1212ed226e9/e66bf/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.png 445w", "/static/fe53d8472f1e8ffb2f48c1212ed226e9/8ce22/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.png 685w"],
              "sizes": "(max-width: 685px) 100vw, 685px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/fe53d8472f1e8ffb2f48c1212ed226e9/8ce22/8719b20c378309194a227a90f89c1788112c1a16-68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67.png",
              "alt": "8719b20c378309194a227a90f89c1788112c1a16 68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67",
              "title": "8719b20c378309194a227a90f89c1788112c1a16 68747470733a2f2f692e696d6775722e636f6d2f514935426152702e706e67",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`What's interesting is that Giphy's iframe embeds a `}<inlineCode parentName="p">{`webp`}</inlineCode>{` version of the gif that's just 880KB for our surprise example. 🤨`}</p>
    <p>{`So iframe should be fastest, right?`}</p>
    <h2 {...{
      "id": "loadinglazy"
    }}>{`loading="lazy"`}</h2>
    <p><inlineCode parentName="p">{`loading="lazy"`}</inlineCode>{` is a `}<a parentName="p" {...{
        "href": "https://addyosmani.com/blog/lazy-loading/"
      }}>{`new native implementation of lazy loading`}</a>{`. Mark something as lazy and the browser avoids loading it until it's visible.`}</p>
    <p>{`I think it's only supported on Chrome right now, but that's where we measure Lighthouse scores isn't it? Also what Google cares about when determining page speed for that sweet sweet SEO boost 😛`}</p>
    <p>{`Lazy loading will almost always give you a speed boost and improve user experience.`}</p>
    <p>{`Where my results get tricky is that the `}<inlineCode parentName="p">{`<video>`}</inlineCode>{` element `}<em parentName="p">{`does not support loading=lazy`}</em>{`. And yet it still gave me a Lighthouse performance boost. From 44 to 63 ...`}</p>
    <p>{`Maybe it's a Lighthouse bug? 🤔`}</p>
    <p>{`Either way, `}<inlineCode parentName="p">{`<video>`}</inlineCode>{` is much better than `}<inlineCode parentName="p">{`<img>`}</inlineCode>{` and I don't like the overlays and extra tracking that comes with `}<inlineCode parentName="p">{`<iframe>`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/ede06cab596cb780947104e17adbc91b/media-JRhS6WoswF8FxE0g2R-giphy.gif",
        "alt": "shrug giphy"
      }}></img></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: I benchmarked using the `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` landing page, changing how 8 gifs are embedded and nothing else.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      